// API Configuration utility
// Use window.location.origin for production to avoid stale env variable issues

export const getBackendUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // For localhost, use env variable or default
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
    }
    // For all production domains, use same origin
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
};

export const BACKEND_URL = getBackendUrl();
export const API_URL = getBackendUrl();

export default getBackendUrl;
